import rbacPlugin from '@backstage-community/plugin-rbac';
import { Content, Header, Page, SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { catalogLocationReadPermission } from '@backstage/plugin-catalog-common/alpha';
import catalogPlugin, {
  CatalogIndexPage,
} from '@backstage/plugin-catalog/alpha';
import { RequirePermission } from '@backstage/plugin-permission-react';
import Typography from '@material-ui/core/Typography';
import { navModule } from './modules/nav';

const restrictedCatalogPlugin = catalogPlugin.withOverrides({
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        loader: async () => (
          <RequirePermission permission={catalogLocationReadPermission}>
            <CatalogIndexPage />
          </RequirePermission>
        ),
      },
    }),
  ],
});

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    loader: async () => (
      <Page themeId="home">
        <Header title="Phoenix V2" />
        <Content>
          <Typography>Choose a tool from the navigation menu.</Typography>
        </Content>
      </Page>
    ),
  },
});

const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      if (configApi.getString('auth.environment') === 'development') {
        return (
          <SignInPage
            {...props}
            providers={[
              'guest',
              {
                id: 'microsoft',
                title: 'Microsoft Active Directory',
                message:
                  'Sign in to Phoenix using your Active Directory account.',
                apiRef: microsoftAuthApiRef,
              },
            ]}
          />
        );
      }
      return (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft',
            title: 'Microsoft Active Directory',
            message: 'Sign in to Phoenix using your Active Directory account.',
            apiRef: microsoftAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    restrictedCatalogPlugin,
    rbacPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
